/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTablet: {
  name: 'tablet';
  data: string;
} = {
  name: 'tablet',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6Zm8 12h10V6H10v12ZM8 6v12H4V6h4Zm-1 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" fill="currentColor"/></svg>`,
};
